export default __webpack_public_path__ + "static/media/PlatosFuertes.946d1bb4.jpg";